export const common = {
  // Navigation
  home: "Home",
  about: "Over Ons",
  services: "Diensten",
  projects: "Realisaties",
  contact: "Contact",
  getQuote: "Offerte Aanvragen",
  
  // Hero Section
  heroTitle: 'Geef leven aan uw renovatieproject in Brussel',
  heroSubtitle: 'Een betrouwbaar, transparant en ervaren Belgisch bedrijf voor uw renovatie- en bouwwerken',
  heroValueLine: 'Gratis offerte • Antwoord binnen 24u • Persoonlijke opvolging',
  heroCTA: 'Vraag een gratis offerte aan',
  
  // Trust Highlights
  trustTitle: 'Waarom kiezen voor Ktran?',
  trustExperience: 'Meer dan 15 jaar praktijkervaring',
  trustLocal: 'Belgisch bedrijf gevestigd in Brussel',
  trustTransparent: 'Duidelijke offerte en strikte opvolging van de werken',
  
  // Services
  servicesTitle: 'Onze Diensten',
  servicesSubtitle: 'Volledige oplossingen voor al uw renovatie- en bouwbehoeften',
  
  masonryTitle: 'Metselwerk',
  masonryDesc: 'Solide en duurzame metselwerken om uw eigendom te beveiligen en te valoriseren',
  
  bathroomTitle: 'Badkamer & Keuken',
  bathroomDesc: 'Moderne, functionele en esthetische ruimtes, ontworpen voor uw dagelijks comfort',
  
  paintingTitle: 'Schilderwerken & Afwerking',
  paintingDesc: 'Verzorgde afwerkingen die uw ruimtes sublimeren en een onberispelijk resultaat garanderen in de tijd',
  
  partitionTitle: 'Scheidingswanden & Isolatie',
  partitionDesc: 'Performante isolatie om uw thermisch comfort te verbeteren en uw energiekosten te verlagen',
  
  carpentryTitle: 'Schrijnwerk',
  carpentryDesc: 'Installatie en renovatie van deuren, ramen en inrichtingen op maat met ambachtelijk vakmanschap',
  
  electricalTitle: 'Elektriciteit',
  electricalDesc: 'Elektrische installaties conform de Belgische normen voor uw veiligheid en gemoedsrust',
  
  // Process Steps
  processTitle: 'Ons Proces',
  processSubtitle: 'Een eenvoudige en transparante aanpak om het succes van uw project te garanderen',
  
  step1Title: 'Analyse van uw project en behoeften',
  step1Desc: 'We luisteren naar uw behoeften en bezoeken de locatie om uw project volledig te begrijpen',
  
  step2Title: 'Gedetailleerde studie en transparante offerte',
  step2Desc: 'We bieden u een gedetailleerde en duidelijke offerte aan, zonder verborgen kosten',
  
  step3Title: 'Uitvoering van de werken met persoonlijke opvolging',
  step3Desc: 'We voeren de werken uit met professionalisme, regelmatige opvolging en constante communicatie',
  
  // Projects
  projectsTitle: 'Onze Realisaties',
  projectsSubtitle: 'Ontdek enkele van onze projecten gerealiseerd in Brussel en omgeving',
  projectNote: 'Een project uitgevoerd met zorg, met respect voor deadlines en budget',
  viewAllProjects: 'Bekijk alle realisaties',
  
  // Value Section
  valueTitle: 'Onze Toewijding aan U',
  valueSubtitle: 'Waarden die elk van onze interventies sturen',
  
  qualityTitle: 'Kwaliteit van het Werk',
  qualityDesc: 'We gebruiken hoogwaardige materialen en passen de beste technieken toe om duurzame en esthetische resultaten te garanderen',
  
  timeTitle: 'Respect voor Deadlines',
  timeDesc: 'Elk project wordt nauwkeurig gepland. We verbinden ons ertoe de overeengekomen deadlines te respecteren voor uw gemoedsrust',
  
  cleanTitle: 'Propere Werf',
  cleanDesc: 'We houden een georganiseerde en propere werf gedurende de hele werken, met een volledige reiniging aan het einde van elke dag',
  
  communicationTitle: 'Transparante Communicatie',
  communicationDesc: 'We houden u op de hoogte bij elke stap van het project. We blijven beschikbaar om uw vragen te beantwoorden en aan te passen volgens uw behoeften',
  
  registeredCompanyDesc: 'Een wettelijk gevestigd en verzekerd bedrijf voor uw veiligheid',
  belgianStandardsDesc: 'Al onze werken respecteren strikt de geldende regelgeving',
  qualityCommitmentDesc: 'Uw tevredenheid is onze prioriteit, van offerte tot definitieve oplevering',
  
  // Final CTA
  finalCTATitle: 'Klaar om uw project te realiseren?',
  finalCTAText: 'Neem vandaag nog contact met ons op voor een gratis en persoonlijke offerte. We begeleiden u van het eerste idee tot de definitieve oplevering',
  finalCTAButton: 'Vraag een gratis offerte aan',
  
  // Footer
  footerAbout: 'Expert in renovatie in Brussel. We transformeren uw ruimtes met kwaliteit en professionalisme',
  footerQuickLinks: 'Snelle Links',
  footerLegal: 'Juridische Vermeldingen',
  footerContact: 'Contact',
  footerRights: 'Alle rechten voorbehouden',
  footerVAT: 'BTW-nr',
  poweredBy: 'Mogelijk gemaakt door BeneluxWeb',
  
  // Legal Pages (Footer Links)
  legalNotice: 'Juridische Vermeldingen',
  privacyPolicy: 'Privacybeleid',
  termsOfUse: 'Gebruiksvoorwaarden',
  cookiePolicy: 'Cookiebeleid',
  dataProtection: 'Gegevensbescherming',
  
  // Common Actions
  learnMore: 'Meer Informatie',
  contactUs: 'Contacteer Ons',
  callUs: 'Bel Ons',
  emailUs: 'Mail Ons',
  
  // Trust Signals
  registeredCompany: 'Geregistreerd bedrijf in België',
  belgianStandards: 'Respect voor Belgische normen',
  qualityCommitment: 'Kwaliteitsverbintenis en klanttevredenheid',
  
  // Stats
  projectsCompleted: 'Voltooide Projecten',
  yearsExperience: 'Jaar Ervaring',
  satisfiedClients: 'Tevreden Klanten',
  projectsDelivered: 'Projecten Opgeleverd',
  
  // Time
  freeQuote: 'Gratis Offerte',
  response24h: 'Antwoord binnen 24u',
  personalizedFollowup: 'Persoonlijke Opvolging'
};
